import { createBrowserHistory } from 'history';
import { pushRoute } from './routeHistory';

export const history = createBrowserHistory();

history.listen((location) => {
	const { pathname, search } = location;
	pushRoute(pathname + search);
});
